import { Injectable } from '@angular/core';
import { InstituteDepartamentModel } from '../model/institute-departaments.model';
import { BaseService } from './base.service';


@Injectable()
export class InstituteDepartamentService {

    path = '/institute-departament';

    constructor(private baseService: BaseService) { }

    findAllInstitutes(){
        return this.baseService.get(this.path, '/');
    }

    findByChecklistId(checklistId: number) {
        return this.baseService.get(this.path, '/by-checklist/' + checklistId);
    }

    getDepartamentsByInstituteId(id: number) {
        return this.baseService.get(this.path, '/' + id);
    }
  
    save(institute_id: number, departaments) {
        return this.baseService.post(this.path, '/', {institute_id, departaments});
    }

    saveInspectablesInChecklist(institute_departaments: InstituteDepartamentModel[], checklist_id) {
        return this.baseService.post(this.path, '/in-checklist/' + checklist_id, institute_departaments);
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/institute-departament.service.ts